import { createFeatureSelector, createReducer, on } from '@ngrx/store';

import { createScopedSelector } from '../../../shared/utils/factory.utils';
import { WHATS_NEW_TOTAL_STEPS } from '../shared/whats-new.config';

import { WhatsNewActions } from './whats-new.actions';

export const WHATS_NEW_STORE_KEY = 'whatsNew';

// state
export interface WhatsNewState {
  isOpen: boolean;
  currentStep: number;
  totalSteps: number;
}

export const initialWhatsNewState: WhatsNewState = {
  isOpen: false,
  currentStep: 1,
  totalSteps: WHATS_NEW_TOTAL_STEPS,
};

// selectors
const selectWhatsNewState = createFeatureSelector<WhatsNewState>(WHATS_NEW_STORE_KEY);
const createWhatsNewSelector = createScopedSelector(selectWhatsNewState);

// reducer
export const whatsNewReducer = createReducer(
  initialWhatsNewState,

  on(
    WhatsNewActions.checkWhatsNewSucceeded,
    (state, { shouldShow }): WhatsNewState => ({
      ...state,
      isOpen: shouldShow,
      currentStep: 1,
    })
  ),

  on(
    WhatsNewActions.openWhatsNew,
    (state): WhatsNewState => ({
      ...state,
      isOpen: true,
      currentStep: 1,
    })
  ),

  on(
    WhatsNewActions.nextWhatsNewStep,
    (state): WhatsNewState => ({
      ...state,
      currentStep: Math.min(state.currentStep + 1, state.totalSteps),
    })
  ),

  on(
    WhatsNewActions.previousWhatsNewStep,
    (state): WhatsNewState => ({
      ...state,
      currentStep: Math.max(state.currentStep - 1, 1),
    })
  ),

  on(
    WhatsNewActions.dismissWhatsNew,
    (state): WhatsNewState => ({
      ...state,
      isOpen: false,
    })
  )
);

export const WhatsNewSelectors = {
  isWhatsNewOpen: createWhatsNewSelector((state: WhatsNewState) => state.isOpen),
  currentWhatsNewStep: createWhatsNewSelector((state: WhatsNewState) => state.currentStep),
  totalWhatsNewSteps: createWhatsNewSelector((state: WhatsNewState) => state.totalSteps),
  isFirstWhatsNewStep: createWhatsNewSelector((state: WhatsNewState) => state.currentStep <= 1),
  isLastWhatsNewStep: createWhatsNewSelector((state: WhatsNewState) => state.currentStep >= state.totalSteps),
};
